export default ["horizontal", "vertical", "horizontal-responsive", "vertical-responsive"];
